import { createAction } from 'redux-act';

export const setNetworkingData = createAction<any>('set networking data');
export const realtimeFetchNetworkingRoom = createAction('fetch realtime networking room details');
export const removeNetworkingRoom = createAction('fetch realtime networking room details');
export const setNetworkingRoomdata = createAction<any>('set networking room details');
